import ApiService from './ApiService';

export default {
  /**
   * Finds marketplaces by Account ID
   * @param {number} accountId Account ID
   * @returns {Promise<any>}
   */
  findByAccount(accountId) {
    return new Promise((resolve, reject) => {
      const data = {
        limit: 1000,
        account_id: accountId,
        includes: 'marketplace',
      };
      ApiService.request('GET', 'marketplaces/credentials', data).then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
  /**
   * Creates credentials.
   * @param {number} accountId Account ID
   * @param {number} marketplaceId Marketplace ID
   */
  create(accountId, marketplaceId) {
    const data = {
      account_id: accountId,
      marketplace_id: marketplaceId,
    };
    return new Promise((resolve, reject) => {
      ApiService.request('POST', 'marketplaces/credentials', data).then((response) => {
        if (response.status === 201) {
          resolve(response.data);
        } else {
          reject(new Error());
        }
      }).catch(() => {
        reject(new Error());
      });
    });
  },
  /**
   * Removes credentials by ID
   * @param {number} credentialsId Credentials ID
   * @returns {Promise<any>}
   */
  remove(credentialsId) {
    return new Promise((resolve, reject) => {
      ApiService.request('DELETE', `marketplaces/credentials/${credentialsId}`, {}).then(() => {
        resolve();
      }).catch(() => {
        reject(new Error());
      });
    });
  },
};
